import { render, staticRenderFns } from "./ExProficiencyBadgeHolder.vue?vue&type=template&id=15bf3e09"
import script from "./ExProficiencyBadgeHolder.vue?vue&type=script&lang=js"
export * from "./ExProficiencyBadgeHolder.vue?vue&type=script&lang=js"
import style0 from "./ExProficiencyBadgeHolder.vue?vue&type=style&index=0&id=15bf3e09&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports